/** `/c/$companyId/settings/fx-rates` — exchange rates; readers of the books' reports see them. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { FxRatesScreen } from "../ledger/FxRatesScreen";

export const Route = createFileRoute("/_auth/c/$companyId/settings/fx-rates")({
  component: FxRatesRoute,
});

function FxRatesRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return <FxRatesScreen companyId={companyId} />;
}
